import type { RouteRecordRaw } from 'vue-router';

export const BP_ROUTER: RouteRecordRaw[] = [
  {
    path: '/bp',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/bp/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/master/bp/views/List.vue'),
        name: 'BP List',
        meta: {
          title: '거래처 마스터',
        },
      },
      {
        path: 'create',
        component: () => import('@/modules/master/bp/views/Detail.vue'),
        name: 'BP Create',
        meta: {
          title: '거래처 등록',
        },
      },
    ],
  },
  {
    path: '/bp/detail/:no',
    component: () => import('@/modules/master/bp/views/Detail.vue'),
    name: 'BP Detail',
    meta: {
      title: '거래처 상세',
      requiresAuth: true,
    },
  },
];
